import { ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { Localisation } from '@workivate/tho-web-shared';
import { usePolyglotT } from 'utils/locale/locale';
import { Header } from 'components/features/shared/header/Header';
import { Footer } from 'components/features/shared/footer/Footer';
import { PageWrapper, Content, Main } from './Page.styles';
import { useRouteValidation } from 'utils/routable/routable';

export interface PageProps {
  children?: ReactNode;
}

export const Page = ({ children }: PageProps) => {
  const { locale } = usePolyglotT();

  useRouteValidation();

  return (
    <PageWrapper>
      <Helmet
        htmlAttributes={{
          lang: Localisation.getCSSLocale(locale),
        }}
      />
      <Header />
      <Content>
        <Main>{children}</Main>
        <Footer />
      </Content>
    </PageWrapper>
  );
};
